import { render, staticRenderFns } from "./ConfigEmailsMailMessageListExpand.vue?vue&type=template&id=d3fcdbbe&"
import script from "./ConfigEmailsMailMessageListExpand.js?vue&type=script&lang=js&"
export * from "./ConfigEmailsMailMessageListExpand.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports